<template>
  <g>
    <g clip-path="url(#clip0_15_447)">
      <path
        d="M22 3.00024H6.99996C6.30996 3.00024 5.76996 3.35024 5.40996 3.88024L0.369956 11.4502C0.149956 11.7902 0.149956 12.2202 0.369956 12.5602L5.40996 20.1202C5.76996 20.6402 6.37996 21.0002 7.06996 21.0002H22C23.1 21.0002 24 20.1002 24 19.0002V5.00024C24 3.90024 23.1 3.00024 22 3.00024ZM8.99996 13.5002C8.16996 13.5002 7.49996 12.8302 7.49996 12.0002C7.49996 11.1702 8.16996 10.5002 8.99996 10.5002C9.82996 10.5002 10.5 11.1702 10.5 12.0002C10.5 12.8302 9.82996 13.5002 8.99996 13.5002ZM14 13.5002C13.17 13.5002 12.5 12.8302 12.5 12.0002C12.5 11.1702 13.17 10.5002 14 10.5002C14.83 10.5002 15.5 11.1702 15.5 12.0002C15.5 12.8302 14.83 13.5002 14 13.5002ZM19 13.5002C18.17 13.5002 17.5 12.8302 17.5 12.0002C17.5 11.1702 18.17 10.5002 19 10.5002C19.83 10.5002 20.5 11.1702 20.5 12.0002C20.5 12.8302 19.83 13.5002 19 13.5002Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_15_447">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 0.000244141)"
        />
      </clipPath>
    </defs>
  </g>
</template>
